// extracted by mini-css-extract-plugin
export default {"userInfoPanel":"UserInfoPanel_userInfoPanel__8C4wo"};